/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerbyWindow = Prefab.createWindow("lorys_derby", "lorys_derby_window_prefab_json");
